import React from 'react';
import { ThemeProvider, unityTheme } from '@exxonmobil/react-unity';
import { Route, Routes } from 'react-router-dom';

import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import { Dashboard } from './dashboard/Dashboard';
import Detail from './detail/Detail';
import MainHeader from './common/components/MainHeader';
import MainFooter from './common/components/MainFooter';
import './App.css';
import { authRequest } from './authConfig';
import Endpoints from './endpoints/Endpoints';
import NotFound from './common/components/NotFound';
import Trends from './trends/Trends';

const App = () => (
  <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest()}>
    <ThemeProvider theme={unityTheme}>
      <div className="content">
        <MainHeader />
        <Routes>
          <Route path="/detail/:id" element={<Detail />} />
          <Route path="/utilization" element={<Endpoints />} />
          <Route path="/trends" element={<Trends />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <MainFooter />
    </ThemeProvider>
  </MsalAuthenticationTemplate>
);

export default App;
